import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface GetStartedSectionProps {
  onGetStarted: () => void;
}

export const GetStartedSection: React.FC<GetStartedSectionProps> = ({
  onGetStarted,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      px: 3,
      backgroundColor: 'background.paper',
      borderRadius: 1,
      boxShadow: 1,
    }}
  >
    <Typography variant="h5" sx={{ mb: 2 }}>
      Get Started with AccuLynx Integration
    </Typography>
    <Typography
      variant="body1"
      color="text.secondary"
      sx={{ mb: 4, textAlign: 'center', maxWidth: 600 }}
    >
      Connect your AccuLynx account to sync your deals and stages. You can set
      up multiple locations and customize stage mappings for each one.
    </Typography>
    <Button
      variant="contained"
      color="primary"
      size="large"
      onClick={onGetStarted}
      startIcon={<AddIcon />}
    >
      Get Started
    </Button>
  </Box>
);
